import ReportCard from "../components/ReportCard";
import axios from "axios";
import Loading from "../components/Loading";
import { useEffect, useState } from "react";
function ReportList(props) {
  const [loading, setLoading] = useState(false);

  const handleDownload = () => {
    setLoading(true);
  };

  useEffect(() => {
    if (loading) {
      axios.get("api/reports/").then((response) => {
        var dataArray = [];
        const data = response.data;
        for (var i in data) {
          dataArray.push(data[i]);
        }
        const fileURL = window.URL.createObjectURL(
          new Blob(
            [
              JSON.stringify(dataArray, null, 2)
                .replaceAll('"', "")
                .replaceAll("\\n", "\n\t\t")
                .replaceAll("\\t", "\t"),
            ],
            { type: "text/json" }
          )
        );

        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download =
          "ReportList_" + new Date(Date.now()).toLocaleString("en-GB") + ".txt";
        alink.click();
        alink.remove();
        setLoading(false);
      });
    }
  }, [loading]);

  return (
    <>
      {props.isLoading ? (
        <Loading></Loading>
      ) : (
        <>
          <div className="button-bar">
            {loading ? (
              <Loading containerDims="Loading" spinnerDims="loading-button" />
            ) : (
              <button className="download-button" onClick={handleDownload}>
                Download All
              </button>
            )}

            {loading ? (
              <Loading containerDims="Loading" spinnerDims="loading-button" />
            ) : (
              <button className="delete-button" onClick={props.onDeleteAll}>
                Delete All
              </button>
            )}
          </div>
          <div className="report-list">
            {props.reports.map((report) => {
              return (
                <ReportCard
                  report={report}
                  onView={props.onView}
                  onDelete={props.onDelete}
                />
              );
            })}
          </div>
        </>
      )}
    </>
  );
}
export default ReportList;
